import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";
import VerticalCenter from "../common/components/VerticalCenter";
import { selectPathType } from "../features/journey/select";
import OffRamp from "./OffRamp";

export default function Question2Intro() {
  const { t } = useTranslation();
  const pathType = useSelector(selectPathType);
  const heading = <h2>{t("Let's learn a little more about you...")}</h2>;

  if (pathType === "GALLERY") return <OffRamp>{heading}</OffRamp>;

  return (
    <VerticalCenter>
      <Padding>
        <Center>{heading}</Center>
      </Padding>
    </VerticalCenter>
  );
}
